import * as React from "react";
import { isBrowser } from "../../utils/auth";

export default function ShareItOnSocial({ data }) {
    const social = [
        {
            name: "facebook",
            icon: (props) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path
                        fillRule="evenodd"
                        d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                        clipRule="evenodd"
                    />
                </svg>
            ),
        },
        {
            name: "twitter",
            icon: (props) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
            ),
        },
        {
            name: "linkedIn",
            icon: (props) => (
                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
                    <g fill="none" fillRule="evenodd">
                        <g>
                            <path d="M0 0L24 0 24 24 0 24z" />
                            <path fill="#9ca3af" fillRule="nonzero" d="M19 3c1.105 0 2 .895 2 2v14c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2h14m-.5 15.5v-5.3c0-1.8-1.46-3.26-3.26-3.26-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4.773 0 1.4.627 1.4 1.4v4.93h2.79M6.88 8.56c.928 0 1.68-.752 1.68-1.68 0-.93-.75-1.69-1.68-1.69-.933 0-1.69.757-1.69 1.69 0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
                        </g>
                    </g>
                </svg>
            ),
        },
    ]

    const hostUrl = isBrowser && window.location.href;

    const shareOnSocial = (event, platform) => {
        event.preventDefault();
        switch (platform) {
            case 'facebook':
                const fbShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${hostUrl}`;
                window.open(fbShareUrl, '_blank', 'height=600,width=600');
                break;
            case 'twitter':
                const twShareUrl = `https://twitter.com/intent/tweet?url=${hostUrl}`;
                window.open(twShareUrl, '_blank', 'height=600,width=600');
                break;
            case 'linkedIn':
                const liShareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${hostUrl}&source=${hostUrl}`;
                window.open(liShareUrl, '_blank', 'height=600,width=600');
                break;
            default:
                break;
        }
    };


    return (
        <div className="max-w-3xl mx-auto my-12 px-4 md:px-0">
            <ul className="rounded-sm divide-y divide-gray-200 bg-gray-100">
                <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                    <div className="w-0 flex-1 flex items-center">
                        <span className="ml-2 flex-1 w-0 truncate text-gray-600"> Share this story </span>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex items-center space-x-2">
                        {
                            social.map((item, index) => (
                                <div role='button' key={index} className="font-medium text-gray-400 hover:text-gray-500 cursor-pointer" onClick={(e) => shareOnSocial(e, item.name)} tabIndex={0} onKeyDown={(e) => shareOnSocial(e, item.name)}>
                                    <span className="sr-only">{item.name}</span>
                                    <item.icon className="h-6 w-6" aria-hidden="true" />
                                </div>
                            ))
                        }
                    </div>
                </li>
            </ul>
        </div>
    )
}
